export default __webpack_public_path__ + "static/media/access-algorithm.ce164343.png";